import React from "react";
import SamoprocenaForma from "../../components/admin/samoprocenaForma";

function SamoprocenaSinglePage(props) {
  return (
    <div className="admin-page-child-wrapper" style={{ position: "relative" }}>
      <SamoprocenaForma />
    </div>
  );
}

export default SamoprocenaSinglePage;
